var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notice-container"},[_c('h2',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),(_vm.noticeItem)?_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.noticeItem.notice)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }